import { LeadFilters, TleadAll } from "../../types";
import { simpleTimeDateFormatter } from "../../utils";

export const toLeadTableFormat = (data: TleadAll[]) => {
    return data.map((e: TleadAll) => ({
        first_name: e?.first_name + " " + e?.last_name,
        source: e?.source,
        sales_status: e?.sales_status,
        name: e?.agent_name,
        phone: e?.phone,
        activity_date: simpleTimeDateFormatter(e?.activity_date) || "",
        appointment_date: simpleTimeDateFormatter(e?.appointment_date),
        created_at: simpleTimeDateFormatter(e?.created_at),
        id: e?.person_id,
        checked: false,
        checkmark: e?.checkmark,
        telemarketer: e?.telemarketer_name,
        house_paid_off: e?.house_paid_off ?? null,
        service_interest: e?.service_interest?.join(', ') || '-',
    }));
};

export const leadDataToIds = (data: any[]) =>
    data
        // .filter((e) => e?.checked)
        .map((m) => m?.id)
        .join("%");

export const LEAD_FILTERS: LeadFilters = {
    source: "",
    source_details: "",
    created_at_to: "",
    created_at_from: "",
    last_activity_to: "",
    last_activity_from: "",
    agent_id: "",
    red_flag: "",
    contacted: "",
    preferred_language: "",
    real_estate_agent: "",
    funding_agent: "",
    telemarketer: "",
    customer_service_rep: "",
    corporation: "",
    gender: "",
    program: "",
    goal: "",
    own_rent: "",
    sales_status: "",
    tags: "",
    state: "",
    loan_officer: "",
    service_interest: "",
    checkmark: "",
    // check: false,
    rate_on_mortgage_from: "",
    rate_on_mortgage_to: "",
    mortgage_pending_balance_from: "",
    mortgage_pending_balance_to: "",
    mortgage_property_value_from: "",
    mortgage_property_value_to: "",
    house_paid_off: "",
};

/**
 * Extract the LeadFilters attributes from any object.
 * @param param0
 * @returns
 */
export const extractFilters = ({
    source = "",
    source_details = "",
    created_at_to = "",
    created_at_from = "",
    last_activity_to = "",
    last_activity_from = "",
    agent_id = "",
    red_flag = "",
    contacted = "",
    preferred_language = "",
    real_estate_agent = "",
    funding_agent = "",
    telemarketer = "",
    customer_service_rep = "",
    corporation = "",
    gender = "",
    program = "",
    own_rent = "",
    goal = "",
    sales_status = "",
    tags = "",
    state = "",
    loan_officer = "",
    service_interest = "",
    checkmark = "",
    rate_on_mortgage_from = "",
    rate_on_mortgage_to = "",
    mortgage_pending_balance_from = "",
    mortgage_pending_balance_to = "",
    mortgage_property_value_from = "",
    mortgage_property_value_to = "",
    house_paid_off = "",
}): LeadFilters => ({
    source,
    source_details,
    created_at_to,
    created_at_from,
    last_activity_to,
    last_activity_from,
    agent_id,
    red_flag,
    contacted,
    preferred_language,
    real_estate_agent,
    funding_agent,
    customer_service_rep,
    loan_officer,
    telemarketer,
    corporation,
    gender,
    program,
    own_rent,
    goal,
    sales_status,
    tags,
    state,
    service_interest,
    checkmark,
    rate_on_mortgage_from,
    rate_on_mortgage_to,
    mortgage_pending_balance_from,
    mortgage_pending_balance_to,
    mortgage_property_value_from,
    mortgage_property_value_to,
    house_paid_off,
});
